import {isEmpty, isNil, isNotNil, uniq} from 'ramda';

import type {GetTrimLevelsApiResponse} from '../../../../../types/api/api';

type TrimLevelRow = NonNullable<NonNullable<GetTrimLevelsApiResponse['trim_levels']>[number]>;

/**
 * Trim levels whose max feature score is strictly greater than the subject vehicle trim's
 * min feature score, plus the vehicle's own trim ("same & better").
 *
 * Returns an empty list when the catalogue is missing/empty or the vehicle trim row lacks
 * usable min/max scores, so callers do not apply a partial guess.
 */
export function getSameAndBetterTrimLevelConstKeys(
  allTrimLevels: TrimLevelRow[] | null | undefined,
  myTrimLevel: string | null | undefined
): string[] {
  if (isNil(myTrimLevel) || isNil(allTrimLevels) || isEmpty(allTrimLevels)) {
    return [];
  }

  const myRow = allTrimLevels.find((t) => t.const_key === myTrimLevel);
  const minScoreOfMyVehicleTrimLevel = myRow?.feature_score_min;
  const myMaxScore = myRow?.feature_score_max;

  if (isNil(minScoreOfMyVehicleTrimLevel) || isNil(myMaxScore)) {
    return [];
  }

  const betterConstKeys = allTrimLevels
    .filter(
      (trimLevel) =>
        isNotNil(trimLevel.feature_score_max) &&
        trimLevel.feature_score_max > minScoreOfMyVehicleTrimLevel
    )
    .map((trimLevel) => trimLevel.const_key)
    .filter(isNotNil);

  return uniq([myTrimLevel, ...betterConstKeys]);
}
